import * as types from '../constants/cidraActions';
import {
  cidMobile, piw, sba
} from '../constants/clientProtocols';
import {
  DUALSIGNOFF_WORKFLOW,
  EPCS_WORKFLOW,
  EPCSAPPROVAL_WORKFLOW,
  EPNONCS_WORKFLOW,
  HELPDESKVERIFICATION_WORKFLOW,
  INHERENCE_ACR_VALUE,
  KNOWLEDGE_ACR_VALUE,
  KNOWLEDGE_OR_INHERENCE_ACR_VALUE,
  KNOWLEDGE_OR_POSSESSION_ACR_VALUE,
  KNOWLEDGE_OR_POSSESSION_OR_INHERENCE_ACR_VALUE,
  POSSESSION_ACR_VALUE,
  POSSESSION_OR_INHERENCE_ACR_VALUE,
  SECONDFACTORONLY_WORKFLOW,
  STRONGUSERVERIFICATION_WORKFLOW,
  USERVERIFICATION_WORKFLOW,
  SELFSERVICE_PWDRESET_CAUI,
  WEBSSO_WORKFLOW
} from '../constants/workflowConstants';

const initialState = {
  startSessionEstablishing: false,
  sessionStarted: false,
  accountToken: null,
  authClient: null,
  authAppId: null,
  authInstanceId: null,
  cloudAuthTenantId: null,
  // Parkland custom entry
  useCustomUX: false,
  authenticationToken: null,
  errorCode: null,
  errorMessage: [],
  modality: null,
  session: null,
  sessionException: null,
  sessionVersion: 0,
  serverState: null,
  serverStateVersion: 0,
  authContextRedirectUrl: null,
  username: null,
  password: null,
  capabilities: null,
  isLoading: false,
  lastFourDigits: null,
  cloudauthEnvironment: null,
  selfServiceEnvironment: null,
  deviceList: [],
  phoneNumber: null,
  complete: false,
  primaryFactorEnrolled: false,
  canSkipEnrollment: false,
  canChangeEnrollmentModality: false,
  isOnboardingWorkflow: true,
  isDeviceManagementWorkflow: false,
  availableModalities: [],
  authenticatedModalities: [],
  isCameraPresent: true,
  manuallyProceedToTempCode: false,
  secondFactorError: false,
  canOptInToSkipSecondFactor: false,
  enableSkipSecondFactor: false,
  skipSecondFactorToken: null,
  skipSecondFactorPeriod: '30 days',
  enterpriseId: null,
  subscriberId: null,
  ignoreTimeout: false,
  sessionService: null,
  oneSignTenantId: null,
  oneSignUserId: null,
  oneSignSessionId: null,
  interplexAddress: null,
  selfServiceVersion: null,
  showInitialTempCode: false,
  selfServiceEnabled: false,
  selfServiceSessionActive: false,
  moreOptionsChooseModality: false,
  cidMobileServiceInfo: null,
  cidErrorCode: null,
  cidErrorMessage: '',
  initialUsername: '',
  initialPassword: '',
  sessionTraceId: null,
  resumeAuthFlowStarted: false,
  resumeAuthFlowToken: null,
  resumeAuthFlowTokenUrl: null,
  forceMfa: false,
  wsFedWa: null,
  wsFedWctx: null,
  wsFedWresult: null,
  wsFedUrl: null,
  matchingNumber: null,
  optionalWorkflowName: null,
  isHelpdeskVerificationWorkflow: false,
  isEpcsWorkflow: false,
  isClinicalWorkflow: false,
  isEntraIdEamIntegration: false,
  isWebSsoWorkflow: false,
  unknownUserForWebSso: false,
  errorHandlerUrl: null,
  requestContext: null,
  icpDomainSuffix: null,
  icpTenantId: null,
  firstAttempt: true,
  allowEditUsername: true,
  cidraAdvancedUi: false,
  stateToken: null,
  // Proximity Card state
  proxReaderConnected: false,
  proxCardData: null,
};

function getAuthContextRedirectUrl(serverState) {
  // In observed PIW responses, authContext.redirectUrl can appear on one
  // serverState and be omitted on a later serverState for the same auth flow.
  // This helper reads the current response value when present and normalizes
  // missing/blank values to null so the reducer can decide whether to retain
  // the last redirectUrl captured for the current session.
  const redirectUrl = serverState?.authContext?.redirectUrl;
  const normalizedRedirectUrl = typeof redirectUrl === 'string'
    ? redirectUrl.trim()
    : null;

  return normalizedRedirectUrl && normalizedRedirectUrl.length > 0
    ? normalizedRedirectUrl
    : null;
}

export default function login(state = initialState, action = {}) {
  switch (action.type) {
  case types.SET_ACCOUNT_TOKEN:
    return {
      ... state,
      accountToken: action.accountToken,
      cloudauthEnvironment: action.cloudauthEnvironment,
      selfServiceEnvironment: action.selfServiceEnvironment,
    };
  case types.LOGOUT:
    return {
      ... initialState,
      initialUsername: state.initialUsername,
      username: state.isEpcsWorkflow || state.isHelpdeskVerificationWorkflow ? state.username : null,
      sessionVersion: state.sessionVersion,
      accountToken: state.accountToken,
      cloudauthEnvironment: state.cloudauthEnvironment,
      selfServiceEnvironment: state.selfServiceEnvironment,
      modality: 'username-password',
      forceMfa: state.resumeAuthFlowToken ? true : state.forceMfa,
      errorHandlerUrl: state.errorHandlerUrl,
      firstAttempt: false,
      cidraAdvancedUi: state.cidraAdvancedUi,
      isHelpdeskVerificationWorkflow: state.isHelpdeskVerificationWorkflow,
      sessionService: state.isHelpdeskVerificationWorkflow ? state.sessionService : null,
      errorCode: state.isHelpdeskVerificationWorkflow ? 'UserNotVerified' : null,
      sessionException: state.isHelpdeskVerificationWorkflow ? {} : null,
      isCameraPresent: state.isCameraPresent,
    };
  case types.RESET:
    return {
      ... initialState,
      initialUsername: state.initialUsername,
      username: state.username,
      sessionVersion: state.sessionVersion,
      accountToken: state.accountToken,
      cloudauthEnvironment: state.cloudauthEnvironment,
      selfServiceEnvironment: state.selfServiceEnvironment,
      modality: 'username-password',
      forceMfa: state.resumeAuthFlowToken ? true : state.forceMfa,
      errorHandlerUrl: state.errorHandlerUrl,
      firstAttempt: false,
      cidraAdvancedUi: state.cidraAdvancedUi,
      isHelpdeskVerificationWorkflow: state.isHelpdeskVerificationWorkflow,
      sessionService: state.isHelpdeskVerificationWorkflow ? state.sessionService : null,
      isCameraPresent: state.isCameraPresent,
    };
  case types.WEB_SSO_AUTH_FLOW_RESET:
    // Preserve applex session, authClient, and tenant/user identity so the
    // outer host wrapper does not see connectionClosedByServer and remount
    // CAUI (which would clear the pending failure error via the nucleus
    // Username primitive's mount-time onInputChange). Clear only the
    // sub-session state populated by the current StartAuthSession +
    // verifyPassword pair. errorCode / errorMessage are intentionally
    // untouched -- the caller sets them via the following LOGIN_FAIL dispatch.
    // Drop the Login Hint on any Web SSO auth failure -- unknown user or
    // wrong password on a known user. Re-populating /username with a value
    // that just failed traps the user on the same field they need to edit.
    return {
      ... state,
      username: null,
      password: null,
      oneSignSessionId: null,
      capabilities: null,
      initialUsername: '',
      unknownUserForWebSso: false,
      isLoading: false,
      modality: 'username-password',
      serverState: null,
    };
  case types.SESSION_CONNECTED:
    return {
      ... state,
      oneSignTenantId: action.oneSignTenantId,
      oneSignUserId: action.oneSignUserId,
      sessionService: action.sessionService,
      authClient: action.authClient,
      allowEditUsername: state.allowEditUsername && action.sessionService !== cidMobile,
    };
  case types.SESSION_SET:
    return {
      ... state,
      session: action.session,
    };
  case types.START_SESSION_ESTABLISHING:
    return {
      ... state,
      startSessionEstablishing: action.startSessionEstablishing,
    };
  case types.SESSION_STARTED:
    return {
      ... state,
      isLoading: false,
      sessionStarted: true,
      session: action.session,
      sessionVersion: action.sessionVersion,
      authAppId: action.authAppId,
      authInstanceId: action.authInstanceId,
      useCustomUX: action.useCustomUX,
      applicationName: action.applicationName,
      modality: action.modality,
      authClient: action.authClient,
    };
  case types.SESSION_AUTH_STARTED:
    return {
      ... state,
      isLoading: false,
      username: action.username,
      password: action.password,
      oneSignSessionId: action.oneSignSessionId,
      authClient: action.authClient,
      capabilities: action.capabilities,
      errorCode: state.sessionService === cidMobile ? state.errorCode : null,
      errorMessage: state.sessionService === cidMobile ? state.errorMessage : [],
    };
  case types.SESSION_FAILED:
    return {
      ... state,
      isLoading: false,
      sessionException: action.sessionException,
      modality: 'autherror',
      errorCode: state.isHelpdeskVerificationWorkflow ? 'UserNotVerified' : null,
    };
  case types.START_DEVICE_MANAGEMENT_WORKFLOW:
    return {
      ... state,
      isDeviceManagementWorkflow: true,
      isOnboardingWorkflow: false,
    };
  case types.END_DEVICE_MANAGEMENT_WORKFLOW:
    return {
      ... state,
      isDeviceManagementWorkflow: false,
      isOnboardingWorkflow: true,
    };
  case types.SET_SELF_SERVICE_DEVICE_MANAGEMENT_ENABLED:
    return {
      ... state,
      selfServiceEnabled: action.ssdmEnabled,
    };
  case types.SET_SELF_SERVICE_VERSION:
    return {
      ... state,
      selfServiceVersion: action.selfServiceVersion,
    };
  case types.SET_SELF_SERVICE_SESSION_ACTIVE:
    return {
      ... state,
      selfServiceSessionActive: action.selfServiceSessionActive,
    };
  case types.SET_SELF_SERVICE_ENVIRONMENT:
    return {
      ... state,
      selfServiceEnvironment: action.selfServiceEnvironment,
    };
  case types.START_LOADING:
    return {
      ... state,
      isLoading: true,
    };
  case types.START_IGNORE_TIMEOUT:
    return {
      ... state,
      ignoreTimeout: true,
    };
  case types.END_IGNORE_TIMEOUT:
    return {
      ... state,
      ignoreTimeout: false,
    };
  case types.IMPRIVATA_ID_PUSH_SUCCESS:
    // falls through
  case types.IMPRIVATA_ID_NUMBER_MATCHING_SUCCESS:
    // falls through
  case types.FINISH_LOADING:
    return {
      ... state,
      isLoading: false,
    };
  case types.START_VERIFY_PASSWORD:
    // falls through
  case types.START_VERIFY_PIN:
    // falls through
  case types.START_VERIFY_TEMPCODE:
    // falls through
  case types.START_VERIFY_SMS:
    // falls through
  case types.START_VERIFY_IMPRIVATA_ID_MANUAL:
    // falls through
  case types.START_VERIFY_OTP:
    // falls through
  case types.START_ENROLL_IMPRIVATA_ID:
    // falls through
  case types.START_ENROLL_SMS:
    // falls through
  case types.START_ENROLL_VERIFY_SMS:
    return {
      ... state,
      errorCode: null,
      errorMessage: [],
      isLoading: true,
    };
  case types.UPDATE_DEVICE_LIST:
    return {
      ... state,
      deviceList: action.deviceList,
    };
  case types.START_CHANGE_PASSWORD:
    return {
      ... state,
      errorCode: null,
      errorMessage: [],
      modality: 'password-reset',
      isLoading: false,
    };
  case types.LOGIN_STARTED:
    return {
      ... state,
      isLoading: false,
      sessionStarted: false,
      session: null,
      sessionException: null,
      // A restart must not inherit the previous connection's service: a stale
      // sessionService satisfies startNewSessionHandler's guard and lets a resume fire
      // before the new connection is live. Clearing it defers the resume to
      // connectionEstablished. Not carved out for helpdesk verification, unlike LOGOUT.
      sessionService: null,
    };
  case types.LOGIN_FAIL:
    return {
      ... state,
      errorCode: action.errorCode,
      errorMessage: action.errorMessage,
      isLoading: false,
      secondFactorError: action.fromUsernameScreen,
      unknownUserForWebSso: false,
    };
  case types.WEB_SSO_UNKNOWN_USER_DEFERRED:
    return {
      ... state,
      unknownUserForWebSso: true,
    };
  case types.CLEAR_LOGIN_ERROR:
    return {
      ... state,
      errorCode: null,
      errorMessage: [],
      secondFactorError: false,
      unknownUserForWebSso: false,
    };
  case types.INPUT_SMS:
    return {
      ... state,
      lastFourDigits: action.lastFourDigits,
      modality: 'sms',
      isLoading: false,
    };
  case types.INPUT_IMPRIVATA_ID_MANUAL:
    return {
      ... state,
      modality: 'iid-manual',
      isLoading: false,
    };
  case types.START_VERIFY_IMPRIVATA_ID:
    return {
      ... state,
      modality: 'iid',
      isLoading: false,
    };
  case types.START_NUMBER_MATCHING_FOR_IMPRIVATA_ID:
    return {
      ... state,
      matchingNumber: action.matchingNumber,
      modality: 'iid',
      isLoading: false,
    };
  case types.INPUT_SMS_ENROLL:
    return {
      ... state,
      modality: 'enrollsms',
      currentStep: 'stepIntroduction',
      canSkipEnrollment: action.canSkipEnrollment,
      canChangeEnrollmentModality: action.canChangeEnrollmentModality,
      isLoading: false,
    };
  case types.INPUT_IMPRIVATA_ID_ENROLL:
    return {
      ... state,
      modality: 'enrollimprivataid',
      currentStep: state.isDeviceManagementWorkflow ? 'stepInput' : 'stepIntroduction',
      canSkipEnrollment: action.canSkipEnrollment,
      canChangeEnrollmentModality: action.canChangeEnrollmentModality,
      isLoading: false,
    };
  case types.START_INPUT_ENROLL_IMPRIVATA_ID:
    // falls through
  case types.START_INPUT_ENROLL_SMS:
    return {
      ... state,
      currentStep: 'stepInput',
      isLoading: false,
    };
  case types.INPUT_PASSWORD:
    return {
      ... state,
      modality: 'password',
      isLoading: false,
    };
  case types.INPUT_EMAIL:
    return {
      ... state,
      modality: 'email',
      isLoading: false,
    };
  case types.INPUT_PIN:
    return {
      ... state,
      modality: 'pin',
      isLoading: false,
    };
  case types.INPUT_TEMPCODE:
    return {
      ... state,
      modality: 'tempcode',
      isLoading: false,
    };
  case types.INPUT_OTP:
    return {
      ... state,
      modality: 'otp',
      challengeText: action.challengeText,
      isLoading: false,
    };
  case types.SMS_ENROLL_SUCCESS:
    return {
      ... state,
      phoneNumber: action.phoneNumber,
      currentStep: 'stepVerify',
      isLoading: false,
      errorCode: null,
      errorMessage: [],
    };
  case types.IMPRIVATA_ID_ENROLL_SUCCESS:
    // falls through
  case types.SMS_ENROLL_VERIFY_SUCCESS:
    return {
      ... state,
      currentStep: 'stepSuccess',
      isLoading: false,
      errorCode: null,
      errorMessage: [],
    };
  case types.IMPRIVATA_ID_MANUAL_SUCCESS:
    // falls through
  case types.SMS_SUCCESS:
    // falls through
  case types.OTP_SUCCESS:
    // falls through
  case types.TEMPCODE_SUCCESS:
    return {
      ... state,
      errorCode: null,
      errorMessage: [],
    };
  case types.PIN_SUCCESS:
    return {
      ... state,
      errorCode: null,
      errorMessage: [],
      manuallyProceedToTempCode: false,
    };
  case types.CHANGE_PASSWORD_SUCCESS:
    // falls through
  case types.PASSWORD_SUCCESS:
    return {
      ... state,
      errorCode: null,
      errorMessage: [],
      password: action.password,
      manuallyProceedToTempCode: false,
    };
  case types.ENROLL_RETRY:
    // falls through
  case types.CHANGE_PASSWORD_RETRY:
    return {
      ... state,
      errorCode: action.errorCode,
      errorMessage: action.errorMessage,
      isLoading: false,
    };
  case types.SET_PRIMARY_FACTOR_ENROLLED:
    return {
      ... state,
      primaryFactorEnrolled: action.isEnrolled,
    };
  case types.SET_AVAILABLE_MODALITIES:
    return {
      ... state,
      availableModalities: action.availableModalities,
    };
  case types.REMOVE_FACE_MODALITY:
    return {
      ... state,
      availableModalities: (state.availableModalities || []).filter(m => m !== 'face'),
      isCameraPresent: false,
    };
  case types.SET_AUTHENTICATED_MODALITIES:
    return {
      ... state,
      authenticatedModalities: action.authenticatedModalities,
      allowEditUsername: state.allowEditUsername && action.authenticatedModalities.length === 0,
    };
  case types.BACK_TO_INTRODUCTION:
    return {
      ... state,
      errorCode: null,
      errorMessage: [],
      currentStep: 'stepIntroduction',
    };
  case types.EDIT_PHONE_NUMBER:
    return {
      ... state,
      errorCode: null,
      errorMessage: [],
      currentStep: 'stepInput',
    };
  case types.LOGIN_SUCCESS:
    return {
      ... state,
      serverState: action.serverState,
      authenticationToken: action.authenticationToken,
      errorCode: null,
      errorMessage: [],
    };
  case types.COMPLETE_AUTHENTICATION:
    return {
      ... state,
      complete: state.authenticationToken ? true : false,
      errorCode: null,
      errorMessage: [],
    };
  case types.SET_SERVER_STATE:
    // For PIW, authContextRedirectUrl stores the latest non-empty redirectUrl
    // we have observed for the current auth session. When a new serverState
    // includes redirectUrl we replace the stored value; when a later PIW
    // serverState omits it, we keep the previously captured value.
    const authContextRedirectUrl = state.sessionService === piw
      && state.optionalWorkflowName === SELFSERVICE_PWDRESET_CAUI
      ? getAuthContextRedirectUrl(action.serverState) || state.authContextRedirectUrl
      : state.authContextRedirectUrl;
    return {
      ... state,
      serverStateVersion: state.serverStateVersion + 1,
      serverState: action.serverState,
      authContextRedirectUrl,
    };
  case types.SET_TEMP_CODE_TO_MANUAL:
    return {
      ... state,
      manuallyProceedToTempCode: true,
    };
  case types.TOGGLE_SKIP_SECOND_FACTOR:
    return {
      ... state,
      enableSkipSecondFactor: action.toggleState,
    };
  case types.SET_SSF_TOKEN:
    return {
      ... state,
      skipSecondFactorToken: action.token,
    };
  case types.SET_ENTERPRISE_ID:
    return {
      ... state,
      enterpriseId: action.enterpriseId,
    };
  case types.SET_SUBSCRIBER_ID:
    return {
      ... state,
      subscriberId: action.subscriberId,
    };
  case types.SET_CID_MOBILE_SERVICE_INFO:
    return {
      ... state,
      cidMobileServiceInfo: action.cidMobileServiceInfo,
    };
  case types.SET_CID_ERROR_INFO:
    return {
      ... state,
      cidErrorCode: action.cidErrorCode,
      cidErrorMessage: action.cidErrorMessage,
    };
  case types.SET_INTERPLEX_ADDRESS:
    return {
      ... state,
      interplexAddress: action.interplexAddress,
    };
  case types.SET_AUTHENTICATION_TOKEN:
    return {
      ... state,
      authenticationToken: action.authenticationToken,
    };
  case types.SET_SSF_AVAILABLE:
    return {
      ... state,
      canOptInToSkipSecondFactor: action.value,
      skipSecondFactorPeriod: action.periodData,
    };
  case types.SHOW_INITIAL_TEMPCODE:
    return {
      ... state,
      showInitialTempCode: action.showInitialTempCode,
    };
  case types.SET_IS_FROM_MORE_OPTIONS_LINK:
    return {
      ... state,
      moreOptionsChooseModality: action.moreOptionsChooseModality,
    };
  case types.SET_INITIAL_USERNAME:
    return {
      ... state,
      initialUsername: action.username,
    };
  case types.SET_INITIAL_PASSWORD:
    return {
      ... state,
      initialPassword: action.password,
    };
  case types.SET_CIDRA_ADVANCED_UI:
    return {
      ... state,
      cidraAdvancedUi: action.cidraAdvancedUi,
    };
  case types.SET_SESSION_TRACE_ID:
    return {
      ... state,
      sessionTraceId: action.sessionTraceId,
    };
  case types.SET_RESUME_AUTH_FLOW_TOKEN:
    return {
      ... state,
      resumeAuthFlowToken: action.resumeAuthFlowToken,
      resumeAuthFlowTokenUrl: null,
    };
  case types.SET_RESUME_AUTH_FLOW_TOKEN_URL:
    return {
      ... state,
      resumeAuthFlowTokenUrl: action.resumeAuthFlowTokenUrl,
    };
  case types.RESTORE_AUTH_SESSION_FROM_IDP_SESSION_SUCCESS:
    return {
      ... state,
      errorCode: null,
      errorMessage: [],
      manuallyProceedToTempCode: false,
    };
  case types.SET_FORCE_MFA:
    return {
      ... state,
      forceMfa: action.forceMfa,
    };
  case types.RESTORE_AUTH_SESSION_FROM_IDP_SESSION_STARTED:
    return {
      ... state,
      resumeAuthFlowStarted: true,
    };
  case types.SET_WS_FED_RESPONSE:
    return {
      ... state,
      wsFedWa: action.wa,
      wsFedWctx: action.wctx,
      wsFedWresult: action.wresult,
      wsFedUrl: action.wsFedUrl,
    };
  case types.SET_OPTIONAL_WORKFLOW_NAME_AND_REQUEST_CONTEXT:
    const isHelpdeskVerificationWorkflow =
      state.isHelpdeskVerificationWorkflow || action.optionalWorkflowName === HELPDESKVERIFICATION_WORKFLOW;
    const isEpcsWorkflow = action.optionalWorkflowName === EPCS_WORKFLOW
      || action.optionalWorkflowName === EPCSAPPROVAL_WORKFLOW;
    const isClinicalWorkflow = action.optionalWorkflowName === EPNONCS_WORKFLOW
      || action.optionalWorkflowName === DUALSIGNOFF_WORKFLOW
      || action.optionalWorkflowName === STRONGUSERVERIFICATION_WORKFLOW
      || action.optionalWorkflowName === USERVERIFICATION_WORKFLOW;
    const isEntraIdEamIntegration = action.optionalWorkflowName === SECONDFACTORONLY_WORKFLOW
      && action.requestContext
      && (action.requestContext.ACR_VALUE === POSSESSION_OR_INHERENCE_ACR_VALUE
        || action.requestContext.ACR_VALUE === KNOWLEDGE_OR_POSSESSION_ACR_VALUE
        || action.requestContext.ACR_VALUE === KNOWLEDGE_OR_INHERENCE_ACR_VALUE
        || action.requestContext.ACR_VALUE === KNOWLEDGE_OR_POSSESSION_OR_INHERENCE_ACR_VALUE
        || action.requestContext.ACR_VALUE === KNOWLEDGE_ACR_VALUE
        || action.requestContext.ACR_VALUE === POSSESSION_ACR_VALUE
        || action.requestContext.ACR_VALUE === INHERENCE_ACR_VALUE);
    const isWebSsoWorkflow = state.sessionService === sba
      && (action.optionalWorkflowName === WEBSSO_WORKFLOW
        || action.optionalWorkflowName === null
        || action.optionalWorkflowName === undefined
        || action.optionalWorkflowName === '');
    const cameraAvailable = (state.isCameraPresent !== false) ? 'true' : 'false';
    const requestContext =
      { ... (action.requestContext || {}), CAMERA_AVAILABLE: cameraAvailable, };
    return {
      ... state,
      optionalWorkflowName: action.optionalWorkflowName,
      requestContext: requestContext,
      isHelpdeskVerificationWorkflow: isHelpdeskVerificationWorkflow,
      isEpcsWorkflow: isEpcsWorkflow,
      isClinicalWorkflow: isClinicalWorkflow,
      isEntraIdEamIntegration: isEntraIdEamIntegration,
      isWebSsoWorkflow: isWebSsoWorkflow,
      allowEditUsername: state.allowEditUsername && !isEpcsWorkflow
        && !isEntraIdEamIntegration && !isHelpdeskVerificationWorkflow,
    };
  case types.SET_ERROR_HANDLER_URL:
    return {
      ... state,
      errorHandlerUrl: action.errorHandlerUrl ? action.errorHandlerUrl : state.errorHandlerUrl,
    };
  case types.INIT_FACE:
    return {
      ... state,
      modality: 'face',
      isLoading: false,
      icpDomainSuffix: action.icpDomainSuffix,
      icpTenantId: action.icpTenantId,
      errorCode: null,
      errorMessage: [],
    };
  case types.START_INITIATE_IDV:
    return {
      ... state,
      modality: 'idv',
      isLoading: true,
      errorCode: null,
      errorMessage: [],
    };
  case types.START_WAIT_IDV_RESULT:
    return {
      ... state,
      modality: 'idv',
      isLoading: false,
      errorCode: null,
      errorMessage: [],
    };
  case types.SET_STATE_TOKEN:
    return {
      ... state,
      stateToken: action.stateToken,
    };
  case types.PROX_READER_STATUS:
    return {
      ... state,
      proxReaderConnected: action.payload.connected,
    };
  case types.PROX_READER_CONNECTED:
    return {
      ... state,
      proxReaderConnected: true,
    };
  case types.PROX_READER_DISCONNECTED:
    return {
      ... state,
      proxReaderConnected: false,
      availableModalities: (state.availableModalities || []).filter(m => m !== 'proxcard'),
    };
  case types.START_VERIFY_PROX_CARD:
    return {
      ... state,
      modality: 'proxcard',
      isLoading: false,
      errorCode: null,
      errorMessage: [],
    };
  case types.REDIRECT_TO_ERROR_PAGE:
    // falls through
  case types.RESTORE_AUTH_SESSION_STARTED:
    // falls through
  case types.RESTORE_AUTH_SESSION_SUCCESS:
    // falls through
  default:
    return state;
  }
}
